export const firebaseConfigConst = {
  id: 'singin-description',
  fontWeight: '400',
  fontFamily: "'Roboto', 'sans-serif'",
  fontSize: '14px',
  lineHeight: '20px',
  color: '#757575',
  margin: '0 0 1em 0',
};
